import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = {
  class: "p-fluid p-formgrid p-grid",
  style: {"alignment":"center"}
}
const _hoisted_3 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { style: {"text-align":"center","alignment":"center"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock("video", {
              height: "700",
              controls: "",
              key: $setup.link,
              autoplay: "",
              loop: "",
              muted: ""
            }, [
              _createElementVNode("source", {
                src: $setup.link,
                type: "video/mp4"
              }, null, 8, _hoisted_4)
            ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}